// extracted by mini-css-extract-plugin
export default {"mainDiv":"DrawerContent_mainDiv__Cy23S","listText":"DrawerContent_listText__nwA2w","textCadabams":"DrawerContent_textCadabams__ZO5mG"};